export default "__VITE_ASSET__Bw1VMaNJ__"